import { ITranslate } from 'src/entity/BasicEntity';

/**
 * 行为常量
 */

/**
 * 药品订单
 */
export const CATEGORY_ORIGINAL = 'Original';
export type CATEGORY_ORIGINAL = typeof CATEGORY_ORIGINAL;
/**
 * 处方订单
 */
export const CATEGORY_PRESCRIPTION = 'Prescription';
export type CATEGORY_PRESCRIPTION = typeof CATEGORY_PRESCRIPTION;
/**
 * 门诊收费订单
 */
export const CATEGORY_OUTPATIENT = 'Outpatient';
export type CATEGORY_OUTPATIENT = typeof CATEGORY_OUTPATIENT;

/**
 * 在线咨询-处方订单
 */
export const CATEGORY_CONSULT_PRESCRIPTION = 'ConsultPrescription';
export type CATEGORY_CONSULT_PRESCRIPTION = typeof CATEGORY_CONSULT_PRESCRIPTION;
/**
 * 支付类型：支付宝
 */
export const PAYMENT_ALIPY = 'AliPay';
export type PAYMENT_ALIPY = typeof PAYMENT_ALIPY;
/**
 * 支付类型：微信
 */
export const PAYMENT_WECHAT = 'WeChat';
export type PAYMENT_WECHAT = typeof PAYMENT_WECHAT;
/**
 * 支付类型：Paypal
 */
export const PAYMENT_PAYPAL = 'PayPal';
export type PAYMENT_PAYPAL = typeof PAYMENT_PAYPAL;
/**
 * 支付类型：记账
 */
export const PAYMENT_POSTPAID = 'PostPaid';
export type PAYMENT_POSTPAID = typeof PAYMENT_POSTPAID;
/**
 * 支付类型：线下付款
 */
export const OFF_LINE = 'Offline';
export type OFF_LINE = typeof OFF_LINE;
/**
 * 支付类型 赠品
 */
export const PAYMENT_GIFT = 'Gift';
export type PAYMENT_GIFT = typeof PAYMENT_GIFT;
/**
 * 支付类型：通联(支付宝)
 */
export const PAYMENT_ALIPAY_ORG = 'SCAN_ALIPAY_ORG';
export type PAYMENT_ALIPAY_ORG = typeof PAYMENT_ALIPAY_ORG;
/**
 * 支付类型：通联(微信)
 */
export const PAYMENT_WECHAT_ORG = 'SCAN_WEIXIN_ORG';
export type PAYMENT_WECHAT_ORG = typeof PAYMENT_WECHAT_ORG;
/**
 * 支付类型：通联(银联)
 */
export const PAYMENT_UNION_ORG = 'SCAN_UNIONPAY_ORG';
export type PAYMENT_UNION_ORG = typeof PAYMENT_UNION_ORG;
/**
 * 支付类型：余额支付
 */
export const PAYMENT_ACCOUNT_BALANCE = 'BALANCE';
type PAYMENT_ACCOUNT_BALANCE = typeof PAYMENT_ACCOUNT_BALANCE;

/**
 * 支付类型：反扫
 */
export const CODEPAY_VSP_ORG = 'CODEPAY_VSP_ORG';
type CODEPAY_VSP_ORG = typeof CODEPAY_VSP_ORG;
/**
 * 支付类型：外部线上
 */
export const EXTERNAL_ONLINE = 'EXTERNAL_ONLINE';
type EXTERNAL_ONLINE = typeof EXTERNAL_ONLINE;
/**
 * 支付类型：外部线下
 */
export const EXTERNAL_OFFLINE = 'EXTERNAL_OFFLINE';
type EXTERNAL_OFFLINE = typeof EXTERNAL_OFFLINE;
/**
 * 支付类型：患者小程序 微信支付
 */
export const WECHAT_MP_PAY_ORG = 'WECHATPAY_MINIPROGRAM_ORG';
type WECHAT_MP_PAY_ORG = typeof WECHAT_MP_PAY_ORG;
/**
 * 支付类型：H5收银台扫码支付
 */
export const H5_CASHIER_VSP_ORG = 'H5_CASHIER_VSP_ORG';
export type H5_CASHIER_VSP_ORG = typeof H5_CASHIER_VSP_ORG;
/**
 * 订单类型
 */
export type ORDER_CATEGORY =
  CATEGORY_ORIGINAL |
  CATEGORY_PRESCRIPTION |
  CATEGORY_OUTPATIENT |
  CATEGORY_CONSULT_PRESCRIPTION;

/**
 * 支付类型
 */
export type ORDER_PAYMENT = PAYMENT_ALIPY | PAYMENT_WECHAT | PAYMENT_PAYPAL |
  PAYMENT_POSTPAID | PAYMENT_ALIPAY_ORG | PAYMENT_WECHAT_ORG | PAYMENT_ACCOUNT_BALANCE | CODEPAY_VSP_ORG |
  PAYMENT_UNION_ORG | EXTERNAL_ONLINE | EXTERNAL_OFFLINE | PAYMENT_GIFT | OFF_LINE | WECHAT_MP_PAY_ORG | H5_CASHIER_VSP_ORG;
/**
 * 可设置支付类型
 */
export type ORDER_PAYMENT_SET = PAYMENT_ALIPY | PAYMENT_PAYPAL;
/**
 * 订单状态
 * @deprecated 使用EPayStatus代替
 */
export enum ORDER_STATUS {
  STATUS_INITIAL = 0,
  STATUS_PENDING = 1,
  /**
   * 已支付/待处理
   */
  STATUS_PAID = 2,
  /** 已发货 */
  STATUS_SENT = 3,
  /** 已签收 */
  STATUS_SIGNED = 4,
  /**
   * 已完成
   */
  STATUS_FINISHED = 5,
  /** 其他 */
  STATUS_OTHER = 6,
}

/**
 * @description 订单支付状态枚举
 * @export
 * @enum {number}
 */
export enum EPayStatus {
  初始状态 = 0,
  待支付 = 10,
  线下待支付 = 11,
  已取消 = 20,
  待发货 = 30,
  已发货 = 40,
  已签收 = 45,
  已完成 = 50,
  已完成线下 = 55,
  退款中 = 100,
  准备退款 = 110,
  拒绝退款 = 120,
  退款失败 = 130,
  已退款 = 140,
  已退款线下 = 145,
  分润中 = 200,
  已分润 = 210,
}

const PAID_GROUP = [EPayStatus.待发货, EPayStatus.线下待支付];
const SENT_GROUP = [EPayStatus.已发货];
const SIGNED_GROUP = [EPayStatus.已签收];
const FINISH_GROUP = [EPayStatus.已完成];
const OTHER_GROUP = [
  EPayStatus.已完成线下,
  EPayStatus.退款中,
  EPayStatus.准备退款,
  EPayStatus.拒绝退款,
  EPayStatus.退款失败,
  EPayStatus.已退款,
  EPayStatus.已退款线下,
  EPayStatus.分润中,
  EPayStatus.已分润,
];

/** 订单是否可以开发票了 */
export function orderCanInvoice(status: EPayStatus) {
  return OTHER_GROUP.findIndex(t => t === status) >= 0;
}

export function orderStateToPayStatus(status: ORDER_STATUS): ReadonlyArray<EPayStatus> {
  let payStatus: EPayStatus[] = [];
  switch (status) {
    case ORDER_STATUS.STATUS_PAID:
      payStatus = PAID_GROUP;
      break;
    case ORDER_STATUS.STATUS_SENT:
      payStatus = SENT_GROUP;
      break;
    case ORDER_STATUS.STATUS_SIGNED:
      payStatus = SIGNED_GROUP;
      break;
    case ORDER_STATUS.STATUS_FINISHED:
      payStatus = FINISH_GROUP;
      break;
    case ORDER_STATUS.STATUS_OTHER:
      payStatus = OTHER_GROUP;
      break;
  }
  return payStatus;
}

export function payStatusToOrderStatus(status: EPayStatus): ORDER_STATUS {
  if (PAID_GROUP.findIndex(s => s === status) >= 0) {
    return ORDER_STATUS.STATUS_PAID;
  } else if (FINISH_GROUP.findIndex(s => s === status) >= 0) {
    return ORDER_STATUS.STATUS_FINISHED;
  } else if (SENT_GROUP.findIndex(s => s === status) >= 0) {
    return ORDER_STATUS.STATUS_SENT;
  } else if (SIGNED_GROUP.findIndex(s => s === status) >= 0) {
    return ORDER_STATUS.STATUS_SIGNED;
  }

  if (OTHER_GROUP.findIndex(s => s === status) >= 0) {
    return ORDER_STATUS.STATUS_OTHER;
  } else {
    return ORDER_STATUS.STATUS_INITIAL;
  }
}

/**
 * 订单类型枚举
 * 和ORDER_CATEGORY定义有冲突，后台定义不统一
 * @export
 * @enum {number}
 */
export enum EnumOrderType {
  处方订单 = 1,
  药品订单 = 2,
  全部订单 = 3,
}

/**
 * 订单类型
 */
export const ConfigOrderType: ITranslate[] = [
  // { key: 'common_status_all', value: EnumOrderType.全部订单 },
  { key: 'order_category_prescription', value: EnumOrderType.处方订单 },
  { key: 'med_agent', value: EnumOrderType.药品订单 },
];



// WEBPACK FOOTER //
// ./src/constants/Order.ts